import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "id";
    return window.localStorage.getItem("asiacommerce-lang") || "id";
  });

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "id" ? "en" : "id";
      if (typeof window !== "undefined") {
        window.localStorage.setItem("asiacommerce-lang", next);
      }
      return next;
    });
  }, []);

  const setLanguage = useCallback((next) => {
    setLang(next);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("asiacommerce-lang", next);
    }
  }, []);

  const t = useMemo(() => translations[lang], [lang]);

  return (
    <LanguageContext.Provider value={{ lang, t, toggle, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
